import {$view, $config} from "@/common/constants";
import {polyfill} from "@/common/utils/polyfill";
import {utils} from "@/common/utils/utils";
import {docCookies} from "@/common/utils/cookies";
import {getViewInfo} from "@/common/utils/infomation";
(function (window) {
	if (!window) return;
	if (!window.xkwTracker) return;
	//JSON
	if (!window.JSON) {
		window.JSON = polyfill.JSON;
	}
	let {on, ajax} = polyfill;
	let view = getViewInfo();
	let prevUrl;
	let url = prevUrl = document.location.href;
	let firstVisit = true;

	addReferrerPolicy();
	setInfomation();
	sentData();

	//解除FIREFOX CHROME 对非同源REFERRER的限制
	function addReferrerPolicy() {
		// var referrerPolicy = 'no-referrer-when-downgrade';
		var referrerPolicy = "unsafe-url";

		var metas = document.querySelectorAll("meta");
		var metaReferrer;
		for (var i = 0; i < metas.length; i++) {
			if (metas[i].name == "referrer") {
				metaReferrer = metas[i];
				break;
			}
		}
		if (metaReferrer) {
			metaReferrer.setAttribute("content", referrerPolicy);
			return;
		}
		metaReferrer = document.createElement("meta");
		metaReferrer.setAttribute("name", "referrer");
		metaReferrer.setAttribute("content", referrerPolicy);
		document.querySelector("head").appendChild(metaReferrer);
	}

	//设置埋点常量
	function setBasic(data) {
		if (data && Object.prototype.toString.call(data) == "[object Object]") {
			for (const key in data) {
				$view[key] = data[key];
			}
		}
	}

	//监控点击事件

	on(document, "click", function (event) {
		let target = null;
		const tags = ["BUTTON", "A", "INPUT","[data-io-click=\"tracker\"]"];
		for (let i = 0; i < tags.length; i++) {
			if (polyfill.closest(event.target, tags[i])) {
				target = polyfill.closest(event.target, tags[i]);
				break;
			}
		}
		if (!target) {
			return;
		}

		if (target.tagName == "INPUT") {
			var type = target.getAttribute("type");
			if (type !== "submit" && type !== "button") {
				return;
			}
		}
		const result = clickEvent(target);
		//setUserInfo();
		sentData(result);
	});


	//单页面应用
	if (window.xkwTracker.$single_page_app) {
		(function (window) {
			//pushState和replaceState监控不到 劫持一下这俩函数
			historyHijack("pushState");
			historyHijack("replaceState");
			window.addEventListener("popstate", eventHandler);
			window.addEventListener("replaceState", eventHandler);
			window.addEventListener("pushState", eventHandler);
		})(window);
	}

	//劫持函数
	function historyHijack(type) {
		(function (orig) {
			window.history[type] = function () {
				const event = new Event(type);
				event.arguments = arguments;
				window.dispatchEvent(event);
				return orig.apply(this, arguments);
			};
		})(window.history[type]);

		// const orig = window.history[type];
		// return function(){
		//     const event = new Event(type);
		//     event.arguments = arguments;
		//     window.dispatchEvent(event);
		//     return orig.apply(this,arguments)
		// }
	}

	function waitUrlChange(newUrl){
		var counter = 0;
		//待URL变化完成后再执行
		//所有的采集都是基于document.location.href;
		newUrl = encodeURIComponent(newUrl);
		return new Promise(function(resolve, reject){
			waitHandler();
			function waitHandler(){
				var docUrl = encodeURIComponent(document.location.href);
				if(docUrl.indexOf(newUrl)>-1){
					resolve(true);
				}
				//1秒后仍未修改网址则抛弃
				if(counter>100){
					reject();
					return;
				}
				counter++;
				setTimeout(waitHandler,10);
			}
		});

	}
	//popState单独处理
	function eventHandler(event) {
		if(event.type=="replaceState" || event.type == "pushState"){
			waitUrlChange(event.arguments[2]).then(response=>{
				stateChange();
			});
			return;
		}
		stateChange();
	}

	function stateChange(){
		setInfomation();
		setTimeout(function () {
			$view.$referrer = url;
			$view.$url = url = document.location.href;
			$view.$url_host = document.location.host;
			$view.$url_path = document.location.pathname;
			//学科网M站用的pushState和replaceState且并没有在其之后马上改变URL，需要拼接
			// if((event.type == 'pushState' || event.type == "replaceState") && document.location.origin.indexOf("m.zxxk.com")>-1){
			//     $view.url_path = event.arguments[2];
			//     $view.$url = url = document.location.origin+$view.url_path;
			// }
			//最近一次站外前向地
			$view.$latest_referrer = "";
			//最近一次站外前向域名
			$view.$latest_referrer_host = "";
			//本次流量来源类型(包含自然)
			$view.$latest_traffic_source_type = utils.getTrafficSource($view.$referrer);
			sentData();
		});
	}

	function setInfomation() {
		//访问时间
		$view.$time = utils.now();
		//获取浏览器信息
		for (const key in view) {
			$view[key] = view[key];
		}
		//浏览信息
		setVisitInfo();
		//设置常量信息
		setBasic(window.xkwTracker);
		//设备ID
		setDeviceId();
		//设置搜索关键词
		setSearchKeyword();
	}

	function setVisitInfo(){
		$view.$referrer = document.referrer;
		$view.$screen_height = window.screen.height;
		$view.$screen_width = window.screen.width;
		$view.$title = document.title;
		$view.$url = document.location.href;
		$view.$url_host = document.location.host;
		$view.$url_path = document.location.pathname;
		if(window.xkwTracker.$single_page_app){
			if(!firstVisit){
				$view.$referrer = prevUrl;
			}
			prevUrl = $view.$url;
		}
		$view.$referrer_host = utils.getHost($view.$referrer);
		//最近一次站外前向地址
		$view.$latest_referrer = utils.getLatestReferrer($view.$referrer);
		//最近一次站外前向域名
		$view.$latest_referrer_host = utils.getHost($view.$latest_referrer);
		//本次流量来源类型(包含自然)
		$view.$latest_traffic_source_type = utils.getTrafficSource($view.$referrer);
		firstVisit = false;
	}

	function getUserInfo() {
		let userInfo = null;
		for (let i = 0; i < $config.ZXXK_USER_INFO_KEYS.length; i++) {
			userInfo = docCookies.getItem($config.ZXXK_USER_INFO_KEYS[i]);
			if (userInfo) break;
		}
		return userInfo;
	}

	//获取cookie中的用户画像
	function getUserImage() {
		return docCookies.getItem($config.ZXXK_USER_IMAGE_KEY);
	}

	function setUserInfo() {
		let userInfo = getUserInfo();
		let userImage = getUserImage();
		if (userImage) {
			$view.$user_id = userImage.userid;
			$view.$stage = userImage.stageid;
			$view.$subject = userImage.subjectid;
			$view.$book_version = userImage.mdm_versionid;
			return;
		}
		if (userInfo) {
			$view.$user_id = userInfo.UserId;
			return;
		}

		$view.$user_id = window.xkwTracker.$user_id;

	}


	//设置搜索关键词
	function setSearchKeyword() {
		var search = document.location.search;
		if(!search) return;
		var site = $config.KEYWORDS.find(function(item){
			return $view.$url_host.indexOf(item.SITE) >-1;
		});

		var domain,host,keyword,latestKeyword;

		if(site){
			host = document.location.host;
			for (var i = 0; i < $config.DOMAINS.length; i++) {
				if (host.indexOf($config.DOMAINS[i]) > -1) {
					domain = "." + $config.DOMAINS[i];
					break;
				}
			}
			keyword = utils.urlToJson(search)[site.QUERY_NAME];
			if(keyword){
				docCookies.setItem(site.COOKIE_NAME,keyword,Infinity, "/", domain);
				$view[$config.SEARCH_COOKIE_NAME] = decodeURIComponent(keyword);
			}
			latestKeyword = docCookies.getItem(site.COOKIE_NAME);
			if(latestKeyword){
				$view[$config.SEARCH_COOKIE_NAME] = decodeURIComponent(latestKeyword);
			}
		}
	}

	//设置设备ID
	function setDeviceId() {
		$view.$device_id = docCookies.getItem("xkw-device-id");
		$view.$is_first_time = false;

		var domain = null;
		var host = document.location.host;
		for (var i = 0; i < $config.DOMAINS.length; i++) {
			if (host.indexOf($config.DOMAINS[i]) > -1) {
				domain = "." + $config.DOMAINS[i];
				break;
			}
		}
		//为了保证用户唯一性，删除子域名下设置的Cookie
		if ($view.$device_id && $view.$device_id !=="null") {
			docCookies.removeItem("xkw-device-id");
			docCookies.setItem("xkw-device-id", $view.$device_id, Infinity, "/", domain);
		} else {
			//浏览器无痕模式下写不了Cookie,传设备ID没有意义
			const deviceId= utils.uuid(32, 16);
			docCookies.setItem("xkw-device-id", deviceId, Infinity, "/", domain);
			$view.$device_id =  docCookies.getItem("xkw-device-id") || "";
			//首次访问
			$view.$is_first_time = true;
		}
	}

	//发送数据
	function sentData(element) {
		let params = utils.jsonToUrl($view);
		if (element) {
			params += "&" + utils.jsonToUrl(element);
		}
		//苹果设备
		//	var isSafari = $view.$browser == "Safari" || $view.$browser == "Mobile Safari" || $view.$os == "iOS" || view.$model == "iPhone";

		//使用浏览器发送数据，不依赖当前页面，即使页面关闭浏览器没关依然可以发送;

		if(navigator.sendBeacon){
			const query = utils.urlToJson("?"+encodeURIComponent(params));
			const data = new FormData();
			Object.keys(query).forEach(function(key){
				data.append(key,decodeURIComponent(query[key]));
			});
			navigator.sendBeacon($config.REQUEST_URL,data);
			return;
		}
		//不支持的话只能使用传统HttpRequest;
		//不再携带COOKIE
		ajax({
			method: "POST",
			async: true,
			url: $config.REQUEST_URL,
			data: params
		});
	}


	function clickEvent(target) {
		setInfomation();
		//获取元素属性
		var position = utils.getElementPosition(target);
		var element = {
			$element_class_name: target.getAttribute("class") || "",
			$element_content: target.innerText,
			$element_id: target.getAttribute("id") || "",
			$element_name: target.getAttribute("name") || "",
			$element_selector: utils.getSelector(target),
			$element_target_url: target.getAttribute("href") || "",
			$element_type: utils.getElementType(target),
			// $last_referrer: document.referrer,
			// $last_referrer_host: utils.getHost(document.referrer),
			// $last_traffic_source_type: utils.getTrafficSource(document.referrer),
			$viewport_width: window.outerWidth,
			$viewport_height: window.outerHeight,
			// $user_agent:navigator.userAgent,
			$offsetx: position.x,
			$offsety: position.y
		};
		return element;
	}

	window.easyData = {
		send: function (customData) {
			//设置常量信息
			setBasic(window.xkwTracker);
			if (customData) {
				sentData({$custom: customData});
				return;
			}
			sentData();
		}
	};

})(window);
